import { ApolloError } from 'apollo-client';
import { GraphQLFormattedError } from 'graphql';

export enum GraphQLPaymentErrorCodes {
  PAYMENTS_ERROR_ALREADY_REGISTERED = 'PAYMENTS_ERROR_ALREADY_REGISTERED',
}

/**
 * Deprecated -- ThreeDS is no longer in use
 */
export class ThreeDSMethodError extends Error {
  constructor() {
    super('Method flow activated');
  }
}

/**
 * Deprecated -- ThreeDS is no longer in use
 */
export class ThreeDSChallengeError extends Error {
  constructor() {
    super('Challenge flow activated');
  }
}

export const normalizeApolloError = (error: ApolloError): Record<string, GraphQLFormattedError> => {
  return error.graphQLErrors.reduce((acc, error) => {
    const key = `${error.extensions?.code || 'GQL_ERROR'}`;
    return { ...acc, [key]: error };
  }, {} as Record<string, GraphQLFormattedError>);
};

export class PaymentAlreadyRegisteredError extends Error {
  constructor() {
    super('Payment already registered');
  }
}
